module.exports = __webpack_public_path__ + "static/media/offsec_logo.13098da7.png";